import React from 'react';
import '../../App.css';
import Cards from '../Projects';
import Footer from '../Footer';

function ProjectsPage(){
    return(
        <>
            <Cards />
            <Footer />
        </>
    );
}

export default ProjectsPage;